import { styled } from '@mui/material';
import { IconTypography } from '@procureai/ui-mui';

export const Address = styled(IconTypography)(({ theme }) => ({
  minWidth: 20,
  color: theme.palette.grey['300'],
}));
